<template>
  <svg
    width="16"
    height="20"
    viewBox="0 0 16 20"
  >
    <path d="M8 0C10.2091 0 12 1.79086 12 4V6H13.75C14.9926 6 16 7.00736 16 8.25V17.75C16 18.9926 14.9926 20 13.75 20H2.25C1.00736 20 0 18.9926 0 17.75V8.25C0 7.00736 1.00736 6 2.25 6H4V4C4 1.79086 5.79086 0 8 0ZM13.75 7.5H2.25C1.83579 7.5 1.5 7.83579 1.5 8.25V17.75C1.5 18.1642 1.83579 18.5 2.25 18.5H13.75C14.1642 18.5 14.5 18.1642 14.5 17.75V8.25C14.5 7.83579 14.1642 7.5 13.75 7.5ZM8.00012 11.5C8.82855 11.5 9.50012 12.1716 9.50012 13C9.50012 13.8284 8.82855 14.5 8.00012 14.5C7.1717 14.5 6.50012 13.8284 6.50012 13C6.50012 12.1716 7.1717 11.5 8.00012 11.5ZM8 1.5C6.61929 1.5 5.5 2.61929 5.5 4V6H10.5V4C10.5 2.61929 9.38071 1.5 8 1.5Z" />
  </svg>
</template>
